module.exports = __webpack_public_path__ + "img/icon.8393049e.png";